import { Box, Card, CardContent, Skeleton } from "@mui/material"

export function StatsCardsSkeleton() {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" }, gap: 2 }}>
      {[...Array(4)].map((_, i) => (
        <Card key={i}>
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Skeleton variant="rounded" sx={{ height: 16, width: 80 }} />
                <Skeleton variant="rounded" sx={{ height: 32, width: 32 }} />
              </Box>
              <Skeleton variant="rounded" sx={{ height: 32, width: 32 }} />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  )
}
